<script context="module">
  export let notifications;
</script>

<script>
  import Notifications from "./Core.svelte";
  const timeout = 4000;
</script>

<Notifications bind:this={notifications} {timeout} />
